/* Track slots measured from Figma ITwOFuf30iVSVfArAADTYs:
   desktop NO 396:1774, YES 391:1458; phone NO 399:2053, YES 383:290.
   Coordinates are relative to the painted track, so real product copy/cart
   controls can grow without detaching the artwork from its junction. */
(() => {
  if (window.GiftGuideMarkerLayout) return;
  const slots = [];
  const mark = (asset, x, y, w, h, inset = 0, flip = false) => ({ asset, x, y, w, h, inset, flip });
  const navy = (x, y) => mark('289-1291', x, y, 36, 55);
  const outline = (x, y) => mark('289-1187', x, y, 35, 53, 2);
  const noBundle = (x, y) => mark('no-bundle', x, y, 36, 55, 2);
  const phone = (asset, x, y, inset = 0) => mark(asset, x, y, 23, 35, inset);
  // Artwork drawn at the right end of a track stays there when the track is
  // wider than the Figma's (phones wider than 390px).
  const fromRight = (source) => ({ ...source, right: true });
  /* KAN-811: stacked phone bottles sit 5.5px apart and clear of what is above
     and below (8px down under the YES / NO box's 2px ring, in a 91px stem), and
     the first-row drops are 64px, so every drawing keeps 5px (plus its
     antialiased edge) from its neighbours and the cards. */
  const add = (segment, device, artwork, { path, width, height, repeat } = {}) => {
    if (!segment || !artwork.length) return;
    const group = document.createElement('span');
    group.className = 'gg-marks gg-marks--figma';
    group.dataset.ggDevice = device;
    group.setAttribute('aria-hidden', 'true');
    if (path) group.dataset.ggPath = path;
    artwork.forEach((source, index) => {
      const slot = document.createElement('span');
      slot.className = 'gg-mark gg-mark--figma';
      slot.style.setProperty('--gg-i', index);
      slot.dataset.ggAsset = source.asset;
      const img = document.createElement('img');
      if (assets[source.asset]) img.src = assets[source.asset].url;
      img.alt = '';
      img.draggable = false;
      img.width = source.w + source.inset * 2;
      img.height = source.h + source.inset * 2;
      if (source.flip) img.style.transform = 'scaleX(-1)';
      slot.append(img);
      group.append(slot);
      slots.push({ segment, slot, img, source, width, height, repeat, group: artwork });
    });
    segment.append(group);
  };
  let assets;
  const prepare = () => {
    const catalog = document.querySelector('[data-gg-marker-assets]');
    if (!catalog) return;
    assets = JSON.parse(catalog.textContent);
    const question = document.querySelector('[data-gg-question]');
    if (question && !question.dataset.ggMarkersPrepared) {
      question.dataset.ggMarkersPrepared = 'true';
      question.querySelectorAll('.gg-marks').forEach((group) => group.remove());
      add(question.querySelector('.gg-stem'), 'desktop', [navy(13.5, 6)]);
      add(question.querySelector('.gg-question__track'), 'desktop', [
        mark('289-1227', 103, 5, 37, 55), mark('289-1235', 160, 5, 36, 55),
        mark('289-1243', 216, 5, 36, 55), outline(837, 6), outline(892, 6), outline(947, 6),
      ], { width: 1119, height: 65 });
    }
    document.querySelectorAll('.gg-board[data-gg-marker-layout]').forEach((board) => {
      const profile = board.dataset.ggMarkerLayout;
      if (!profile || profile === 'generic' || board.dataset.ggMarkersPrepared) return;
      board.dataset.ggMarkersPrepared = 'true';
      board.querySelectorAll('.gg-marks').forEach((group) => group.remove());
      const stem = board.querySelector('.gg-stem');
      const bar = board.querySelector('.gg-bar');
      const drops = [...board.querySelectorAll('.gg-drop')];
      const left = board.querySelector('.gg-leg--left');
      const right = board.querySelector('.gg-leg--right');
      if (profile === 'first-no') {
        add(stem, 'phone', [phone('403-2425', 9, 8, .5), phone('403-2425', 9, 49.5, .5)]);
        add(bar, 'desktop', Array.from({ length: 16 }, (_, i) => outline(33 + i * 55, 5.5)), { width: 947, height: 65, repeat: true });
        drops.forEach((drop, i) => add(drop, 'desktop', [outline([15, 15.5, 14.5][i], 3.5)]));
      } else if (profile === 'first-yes') {
        add(stem, 'desktop', [navy(14, 15), navy(14, 90)]);
        add(stem, 'phone', [phone('399-2224', 8, 8), phone('399-2224', 8, 49.5)]);
        add(bar, 'desktop', Array.from({ length: 6 }, (_, i) => navy(64.5 + i * 56, 5)), { width: 400, height: 65, repeat: true });
      } else if (profile === 'bundles') {
        add(stem, 'desktop', [noBundle(15, 20)], { path: 'no' });
        add(stem, 'desktop', [navy(15, 16.5)], { path: 'yes' });
        add(stem, 'phone', [phone('403-2473', 9, 6.5, .5), phone('403-2473', 9, 48, .5)], { path: 'no' });
        add(stem, 'phone', [phone('403-2242', 9, 6.5), phone('403-2242', 9, 48)], { path: 'yes' });
        drops.forEach((drop, i) => {
          add(drop, 'desktop', [noBundle(14, -41), noBundle(14, 34)], { path: 'no' });
          add(drop, 'desktop', [navy(i % 2 ? 17.5 : 12, -48.5), navy(i % 2 ? 17.5 : 12, 26.5)], { path: 'yes' });
        });
        for (const path of ['no', 'yes']) {
          const no = path === 'no';
          add(bar, 'phone', [
            mark(no ? '403-2481' : '403-2417', 25, 4, 34, 25, no ? .53 : 0, true),
            fromRight(mark(no ? '403-2480' : '383-343', 291, 4, 34, 25, no ? .53 : 0)),
          ], { path, width: 350, height: 40 });
          add(left, 'phone', [mark(no ? '403-2506' : '403-2411', 16, -14, 10, 42, no ? .5 : 0),
            mark(no ? '403-2478' : '383-342', 14, 40, 13, 35, no ? .5 : 0)], { path });
          add(right, 'phone', [mark(no ? '403-2478' : '403-2406', 13, -11, 13, 35, no ? .5 : 0),
            mark(no ? '403-2477' : '383-341', 15, 33, 10, 42, no ? .5 : 0)], { path });
        }
      } else if (profile === 'budget') {
        const box = (x, y) => mark('box', x, y, 55, 33);
        const a = (x, y) => mark('289-979', x, y, 10.7809768, 34.3530849);
        const b = (x, y) => mark('289-995', x, y, 14.9981291, 33.9289261);
        const c = (x, y) => mark('289-1011', x, y, 13.1447056, 34.1923773);
        const lighter = (x, y) => mark('289-1003', x, y, 9, 46);
        add(bar, 'desktop', [a(77,15.827345),box(107.78125,16.503906),b(182.780928,16.03955),lighter(217.779297,10.003906),c(246.779297,15.907955),box(279.923828,16.503906),
          b(612.999678,16.03955),box(647.998047,16.503906),c(722.998047,15.907955),lighter(756.142578,10.003906),b(785.143233,16.03955),lighter(820.140625,10.003906),c(849.140625,15.907955),box(882.286133,16.503906),b(957.285811,16.03955),lighter(992.28418,10.003906)], { width: 1039, height: 65 });
        add(drops.at(-1), 'desktop', [mark('289-1251',31,9.003659,13.1447056,34.1923773)]);
        add(bar, 'phone', [fromRight(mark('mobile-budget',197.986328,5,107.000603,124))], { width: 315, height: 40 });
      }
    });
    layout();
  };
  /*
    Keep every bottle at least GAP px clear of text, badges, cards, the YES / NO
    boxes and other bottles (KAN-811). A bottle that is too close moves the
    least distance that clears it, up to MAX_SHIFT px and only while it stays on
    the painted track; when no such move exists it is hidden at that width.
  */
  // 5px, plus half a pixel for the antialiased edge of each drawing.
  const GAP = 5.5;
  const MAX_SHIFT = 12;
  const shown = (el) => el.getClientRects().length > 0 && getComputedStyle(el).visibility !== 'hidden';
  const gapBetween = (a, b) => Math.max(b.left - a.right, a.left - b.right, b.top - a.bottom, a.top - b.bottom);
  const moved = (r, dx, dy) => ({ left: r.left + dx, right: r.right + dx, top: r.top + dy, bottom: r.bottom + dy });
  const inside = (x, y, rects) => rects.some((t) => x >= t.left - 0.5 && x <= t.right + 0.5 && y >= t.top - 0.5 && y <= t.bottom + 0.5);
  const obstacles = () => {
    const found = [];
    document.querySelectorAll('.gg .gg-card, .gg .gg-choice, .gg .gg-badge__star').forEach((el) => {
      if (!shown(el)) return;
      const r = el.getBoundingClientRect();
      const style = getComputedStyle(el);
      // Outside strokes (the YES / NO rings) are outlines, beyond the box.
      const ring = style.outlineStyle === 'none' ? 0 : Math.max(0, parseFloat(style.outlineWidth) + parseFloat(style.outlineOffset));
      found.push({ left: r.left - ring, right: r.right + ring, top: r.top - ring, bottom: r.bottom + ring });
    });
    document.querySelectorAll('.gg .gg-bar, .gg .gg-question__track').forEach((root) => {
      const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
      for (let node = walker.nextNode(); node; node = walker.nextNode()) {
        if (!node.textContent.trim() || !shown(node.parentElement) || node.parentElement.closest('.gg-marks')) continue;
        const range = document.createRange();
        range.selectNodeContents(node);
        found.push(...Array.from(range.getClientRects()).filter((r) => r.width > 0));
      }
    });
    return found;
  };
  const clear = () => {
    const blockers = obstacles();
    const tracks = Array.from(document.querySelectorAll('.gg .gg-track')).filter(shown).map((t) => t.getBoundingClientRect());
    slots.forEach(({ slot, segment, img }) => {
      slot.style.visibility = slot.dataset.ggOut ? 'hidden' : '';
      if (slot.dataset.ggOut || !shown(slot) || !shown(segment)) return;
      // The drawn artwork, which can reach past its slot by the stroke's inset.
      const box = (img.isConnected ? img : slot).getBoundingClientRect();
      if (!box.width) return;
      const near = (r) => blockers.filter((b) => gapBetween(r, b) < GAP);
      const hits = near(box);
      if (!hits.length) {
        blockers.push(box);
        return;
      }
      const onTrack = tracks.filter((t) => gapBetween(box, t) < 0);
      const fits = (r) => [[r.left, r.top], [r.right, r.top], [r.left, r.bottom], [r.right, r.bottom]]
        .every(([x, y]) => inside(x, y, onTrack));
      const moves = hits
        .flatMap((b) => [[b.left - GAP - box.right, 0], [b.right + GAP - box.left, 0], [0, b.top - GAP - box.bottom], [0, b.bottom + GAP - box.top]])
        .filter(([dx, dy]) => Math.abs(dx + dy) <= MAX_SHIFT)
        .sort((a, b) => Math.abs(a[0] + a[1]) - Math.abs(b[0] + b[1]));
      const move = moves.find(([dx, dy]) => {
        const r = moved(box, dx, dy);
        return fits(r) && !near(r).length;
      });
      if (!move) {
        slot.style.visibility = 'hidden';
        return;
      }
      const [dx, dy] = move.map((d) => Math.sign(d) * Math.ceil(Math.abs(d) * 2) / 2);
      slot.style.left = `${parseFloat(slot.style.left) + dx}px`;
      slot.style.top = `${parseFloat(slot.style.top) + dy}px`;
      blockers.push(moved(box, dx, dy));
    });
  };
  const layout = () => {
    slots.forEach(({ segment, slot, img, source, width, height, repeat, group }) => {
      const box = segment.getBoundingClientRect();
      // A row of identical bottles keeps its size and spacing on a shorter
      // track and shows as many as fit, with the Figma's margin at the end.
      const scale = width && !repeat ? Math.min(1, box.width / width) : 1;
      const end = repeat ? width - Math.max(...group.map((s) => s.x + s.w)) : 0;
      slot.dataset.ggOut = repeat && source.x + source.w > box.width - end ? 'true' : '';
      const top = (height ? (box.height - height * scale) / 2 : 0) + source.y * scale;
      slot.style.left = `${source.right && width ? box.width - (width - source.x) * scale : source.x * scale}px`;
      slot.style.top = `${top}px`;
      slot.style.width = `${source.w * scale}px`;
      slot.style.height = `${source.h * scale}px`;
      if (source.asset === 'box') {
        slot.classList.add('gg-mark--figma-box');
        img.remove();
      } else {
        img.style.left = img.style.top = `${-source.inset * scale}px`;
        img.style.width = `${assets[source.asset].width * scale}px`;
        img.style.height = `${assets[source.asset].height * scale}px`;
      }
    });
    clear();
  };
  window.GiftGuideMarkerLayout = { prepare, layout };
})();
